import React from "react";
import { FormData } from "../types";
import { TextField } from "../../../components/ui/Field";

interface AddressSectionProps {
  type: "event" | "factuur";
  formData: FormData;
  disabled?: boolean;
  onAddressChange: (field: keyof FormData, value: string) => void;
  validationErrors?: { [key: string]: string };
}

// Street, number, postcode and city for the event location or the invoice address
export const AddressSection: React.FC<AddressSectionProps> = ({
  type,
  formData,
  disabled = false,
  onAddressChange,
  validationErrors = {},
}) => {
  const field = (suffix: "Straat" | "Huisnummer" | "Postcode" | "Gemeente") => {
    const name = `${type}${suffix}` as keyof FormData;
    return {
      name,
      value: formData[name] as string,
      onValueChange: (value: string) => onAddressChange(name, value),
      error: validationErrors[name],
      disabled,
    };
  };

  return (
    <div className="grid gap-4 sm:grid-cols-[1fr_8rem]">
      <TextField label="Straat" autoComplete={type === "event" ? "off" : "street-address"} {...field("Straat")} />
      <TextField label="Nr." {...field("Huisnummer")} />
      <TextField label="Postcode" inputMode="numeric" autoComplete={type === "event" ? "off" : "postal-code"} wrapperClassName="sm:order-4" {...field("Postcode")} />
      <TextField label="Gemeente" autoComplete={type === "event" ? "off" : "address-level2"} wrapperClassName="sm:order-3" {...field("Gemeente")} />
    </div>
  );
};
